import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
// 获取用户签名
export const getUserSign = (params) => {
  return request(`${mock}/v1/im/getUserSign`, "get", { params });
};
// 获取会话列表
export const getConversationList = (params) => {
  return request(`${mock}/v1/im/getConversationList`, "get", { params });
};
// 获取消息列表
export const getMessageList = (params) => {
  return request(`${mock}/v1/im/getMessageList`, "get", { params });
};
// 获取未读消息数
export const getUnreadImCount = (params) => {
  return request(`${mock}/v1/im/getUnreadImCount`, "get", { params });
};
// 撤回消息
export const handleRevokeMessageByServer = (params) => {
  return request(`${mock}/v1/im/withdrawMsg`, "post", { json: params });
};
// 设置免打扰 is_no_disturbing 1 是 2 否
export const setNoDisturbing = (params) => {
  return request(`${mock}/v1/im/setNoDisturbing`, "post", { json: params });
};
// 设置会话置顶
export const setTop = (params) => {
  return request(`${mock}/v1/im/setTop`, "post", { json: params });
};
// 移除对话
export const removeConversation = (params) => {
  return request(`${mock}/v1/im/delConversation`, "post", { json: params });
};

// 保存群公告
export const saveImGroupBulletin = (params) => {
  return request(`${mock}/v1/im/saveImGroupBulletin`, "post", { json: params });
};
// 获取公告
export const getImGroupBulletin = (params) => {
  return request(`${mock}/v1/im/getImGroupBulletin`, "get", { params });
};
// 判断是否有该群的邀请权限
export const checkGroupInvite = (params) => {
  return request(`${mock}/v1/im/checkGroupInvite`, "get", { params });
};
// 创建对话
export const createConversation = (params) => {
  return request(`${mock}/v1/im/createConversation`, "POST", { json: params });
};

// 获取群聊私聊列表
export const getGroupPrivateList = (params) => {
  return request(`${mock}/v1/im/getGroupPrivateList`, "get", { params });
};

// 获取群聊私聊未读消息数
export const getGroupPrivateUnread = (params) => {
  return request(`${mock}/v1/im/getGroupPrivateUnread`, "get", { params });
};

//设置群聊私聊未读消息为已读
export const setGroupPrivateUnread = (params) => {
  return request(`${mock}/v1/im/setMessageToRead`, "get", {
    params,
  });
};
